function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Lunacy");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M0 0L19 0L19 18L0 18L0 0Z",
  id: "location_path_1"
}), /*#__PURE__*/React.createElement("clipPath", {
  id: "location_mask_1"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#location_path_1"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "maps-and-flags-1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0L19 0L19 18L0 18L0 0Z",
  id: "maps-and-flags-1-(Background/Mask)",
  fill: "none",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#location_mask_1)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(2.6191406 0)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 6.51888C0 10.9798 6.15789 17.5287 6.42007 17.8053C6.66633 18.0651 7.09628 18.0647 7.34209 17.8053C7.60427 17.5287 13.7622 10.9798 13.7622 6.51888C13.7621 2.92437 10.6753 0 6.88108 0C3.08683 0 0 2.92437 0 6.51888ZM3.41907 6.51888C3.41907 4.71037 4.97214 3.23909 6.88108 3.23909C8.79002 3.23909 10.3431 4.71041 10.3431 6.51892C10.3431 8.32743 8.79002 9.79871 6.88108 9.79871C4.9721 9.79871 3.41907 8.32739 3.41907 6.51888Z",
  id: "Vector",
  fill: "#FFD300",
  fillRule: "evenodd",
  stroke: "none"
})))));

var SvgLocation = function SvgLocation(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "18px",
    viewBox: "0 0 19 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLocation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/location.f50797a3.svg";
export { ForwardRef as ReactComponent };